import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { i18n } from '../data/i18n.js';
import { withFirebase } from '../auth/firebase/context';
import styles from '../css/Login.module.css';

class LoginFormBase extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            error: ''
        };
    }

    onChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    onSubmit = event => {
        const { email, password } = this.state;
        const { firebase } = this.props;

        firebase
            .signIn(email, password)
            .then(authUser => {
                this.setState({
                    email: '', 
                    password: '', 
                    error: null
                });
                this.props.history.push('/dashboard');
            })
            .catch(error => {
                this.setState({ error });
            });
        event.preventDefault();
    }

    render() {
        const { email, password, error } = this.state;

        const isInvalid = password.length <= 0 || email.length <= 0;

        return(
            <div className={styles.module}>
                <h2>View your project UX overview</h2>
                <form className={styles.loginForm} onSubmit={this.onSubmit}>
                    <label htmlFor="email" className={styles.emailLabel}>{i18n.se.loginview.emailfield.label}</label>
                    <input 
                        type="email"
                        placeholder={i18n.se.loginview.emailfield.placeholder}
                        name="email"
                        value={email}
                        onChange={this.onChange}
                        className={styles.email}
                    />
                    <label htmlFor="password"  className={styles.passwordLabel}>{i18n.se.loginview.passwordfield.label}</label>
                    <input 
                        type="password"
                        placeholder={i18n.se.loginview.passwordfield.placeholder}
                        name="password"
                        value={password}
                        onChange={this.onChange}
                        className={styles.password}
                    />
                    <button className={styles.button} type="submit" disabled={isInvalid}>Login</button>
                    {error && <p className={styles.error}>{error.message}</p>}
                </form>
            </div>
        );
    }
}

export default withRouter(withFirebase(LoginFormBase));